import React from 'react';
import TextField from '@material-ui/core/TextField';

export default function DatePickers(props) {

  const {item, onChange} = props;
  const {id, label, labelWidth, value, required, error, disable} = item;

  return (
    <TextField
      value={value}
      required={required}
      fullWidth
      variant='outlined'
      id={id || label}
      type="date"
      defaultValue={value}
      error={error}
      helperText={error}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(event) => {
        onChange(event.target.value, id || label)
      }}
      label={label}
      labelWidth={labelWidth}
      disabled={disable}
    />
  );
}
